import PublicLayout from "@/components/PublicLayout";
import { Cross, Heart, BookOpen, Sun } from "lucide-react";

export default function About() {
  return (
    <PublicLayout>
      <section className="celestial-bg">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-20">
          <p className="text-xs uppercase tracking-widest text-brand-quiet">About Christianity</p>
          <h1 className="mt-3 font-serif text-5xl sm:text-6xl tracking-tight text-brand-ink">
            The good news, in plain words.
          </h1>
          <p className="mt-6 text-lg text-brand-quiet leading-relaxed">
            Christianity is not a list of rules — it is a person, Jesus Christ, who came to rescue
            people from sin and bring them home to God. The Bible tells one continuous story: God
            made us, we wandered, He came after us, and through Christ’s death and resurrection He
            offers full forgiveness and a new heart to anyone who turns to Him.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 lg:px-8 py-16 space-y-12">
        <Block
          icon={Cross}
          title="The Cross"
          body="Jesus, fully God and fully man, lived a sinless life and willingly went to the cross. There He bore the punishment our sins deserved (Isaiah 53:5; Romans 5:8). Three days later He rose from the dead, proving that sin and death do not have the final word."
        />
        <Block
          icon={Heart}
          title="Grace, not performance"
          body="“For by grace you have been saved through faith, and that not of yourselves; it is the gift of God, not of works, lest anyone should boast.” — Ephesians 2:8-9. You don’t earn forgiveness. You receive it."
        />
        <Block
          icon={BookOpen}
          title="The Bible"
          body="The Old Testament prepares us for Christ; the New Testament reveals Him. Together they are God’s loving voice to His people — true, sufficient, and full of life (2 Timothy 3:16-17)."
        />
        <Block
          icon={Sun}
          title="A new life"
          body="When you trust Christ, the Holy Spirit makes you new (2 Corinthians 5:17). Old habits begin to loosen. New affections grow. Sin still struggles, but Christ has already won. This app exists to walk with you in that day-by-day becoming."
        />
      </section>

      <section className="bg-white border-t border-brand-line">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16 text-center">
          <p className="scripture-quote text-3xl text-brand-ink leading-snug">
            “Whoever comes to Me, I will by no means cast out.”
          </p>
          <p className="text-sm text-brand-muted mt-3">— John 6:37</p>
        </div>
      </section>
    </PublicLayout>
  );
}

function Block({ icon: Icon, title, body }) {
  return (
    <div className="flex gap-5">
      <span className="shrink-0 w-12 h-12 rounded-full bg-brand-mist text-brand-skyDark grid place-items-center">
        <Icon className="w-5 h-5" strokeWidth={1.6} />
      </span>
      <div>
        <h2 className="font-serif text-3xl text-brand-ink tracking-tight">{title}</h2>
        <p className="mt-3 text-brand-quiet leading-relaxed">{body}</p>
      </div>
    </div>
  );
}
